export const styles = {
  color: "#FFFFFF",
  letterSpacing: 0.3,
  textTransform: "capitalize",
};
